import { onBeforeUnmount, toValue, watch } from 'vue';

export const useInfiniteScroll = (anchorRef, { hasNextPage, isFetchingNextPage, fetchNextPage }) => {
  let observer = null;

  const disconnect = () => {
    observer?.disconnect();
    observer = null;
  };

  const handleIntersect = ([entry]) => {
    if (entry.isIntersecting && toValue(hasNextPage) && !toValue(isFetchingNextPage)) fetchNextPage();
  };

  watch(
    [anchorRef, () => toValue(isFetchingNextPage)],
    ([anchor, isFetching]) => {
      disconnect();
      if (!anchor || isFetching) return;

      observer = new IntersectionObserver(handleIntersect);
      observer.observe(anchor);
    },
    { immediate: true, flush: 'post' }
  );

  onBeforeUnmount(disconnect);
};
